import { MultiSelect } from "components/Select";

import { QUOTE_STATUS_OPTIONS } from "./quoteStatusFilterGroups";

import type { SelectProps } from "@mui/material";

interface Props {
  value?: string[];
  onChange: (value: string[]) => void;
  selectProps?: SelectProps;
  label?: string;
  width?: string | number;
}

export function QuoteStatusMultiSelect(props: Props) {
  const { value, onChange, selectProps, label, width = 200 } = props;

  return (
    <MultiSelect
      inputLabel={label ?? "Quote Status"}
      defaultValue={[]}
      value={value}
      onChange={onChange}
      options={QUOTE_STATUS_OPTIONS}
      selectProps={selectProps}
      width={width}
    />
  );
}
